import React, { useState } from 'react';
import { screenshotSrc } from '../data/projects';
import '../styles/ScreenshotFrame.css';

// Frame that shows the screenshot at its own aspect ratio once the file exists in
// public/images/case-studies/<slug>/, and a 16:10 labelled placeholder until then.
const ScreenshotFrame = ({ slug, screenshot }) => {
  const [status, setStatus] = useState('loading');
  const { file, label, alt } = screenshot;

  return (
    <figure className={`screenshot-frame is-${status}`}>
      {status !== 'loaded' && (
        <div
          className="screenshot-placeholder"
          role="img"
          aria-label={`${label}: screenshot coming soon`}
          aria-hidden={status === 'loading'}
        >
          <span className="screenshot-label">{label}</span>
          <span className="screenshot-caption">Screenshot coming soon</span>
        </div>
      )}
      {status !== 'error' && (
        <img
          src={screenshotSrc(slug, file)}
          alt={alt}
          loading="lazy"
          onLoad={() => setStatus('loaded')}
          onError={() => setStatus('error')}
        />
      )}
    </figure>
  );
};

export default ScreenshotFrame;
